<div>
  <div class="spacer"></div>
  <div class="anim-box center spacer">
    <div></div>
    <div class="scanner"></div>
  </div>
  <div class="spacer"></div>
</div>
